import i18n from "../../i18n";
import React, { useEffect, useState } from "react";
import { useAuthUser } from "react-auth-kit";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "@mantine/core";
import { Page } from "../../layout/page";
import UserCPDDetail from "../../components/userCPDDetail";
import { useServerApi } from "../../hooks/userServerApi";

const MyCPD = ({}) => {
	const auth = useAuthUser();
	const authUser = auth();
	const [api] = useServerApi();
	const [user, setUser] = useState(authUser);
	const navigate = useNavigate();
	const location = useLocation();
	const [refreshKey, setRefreshKey] = useState(0);
	const isConsultantPortal = location.pathname.startsWith("/consultant/");

	useEffect(() => {
		if (location.state?.cpdSubmitted) {
			setRefreshKey((value) => value + 1);
			navigate(location.pathname, { replace: true, state: {} });
		}
	}, [location.state, location.pathname, navigate]);

	useEffect(() => {
		const userId = authUser?.id || authUser?._id;
		if (!userId) return;

		let cancelled = false;
		(async () => {
			try {
				const profile = await api.getById({ apiEntity: "user", id: userId });
				if (!cancelled && profile) setUser(profile);
			} catch (error) {
				console.log(error);
			}
		})();

		return () => {
			cancelled = true;
		};
	}, [authUser?.id, authUser?._id, refreshKey]);

	return (
		<Page
			title={"My CPD & CPT"}
			actions={
				isConsultantPortal ? (
					<Button onClick={() => navigate("/consultant/myCPD/submit")}>{i18n.t("Submit Certificate")}</Button>
				) : null
			}
		>
			<UserCPDDetail mainUser={user} refreshKey={refreshKey} />
		</Page>
	);
};

export default MyCPD;
